import Checkpoint, { ORDER_EXCLUDED } from "./checkpoint";

export default class OptionsCheckpoint extends Checkpoint {
    constructor() {
        super('options', 'Options', '', { iconClass: 'fas fa-bars' })
    }

    get defaultOrder(){
        return ORDER_EXCLUDED;
    }

    isConfiguredForConnection(connection){
        return true; //Always configured
    }

    isActiveForConnection(connection){
        return true;
    }

    buildTooltip(connection) {
        return {
            title: 'Options',
        }
    }
}